import {
  INIT_URL,
  SIGNOUT_USER_SUCCESS,
  USER_DATA,
  USER_TOKEN_SET,
  MFA_RESPONSE_DATA,
  TEMPORARY_USER_TOKEN,
  SET_USER_BIO_AUTH_PASSED,
  SET_USER_BIO_AUTH_CHECKING
} from "../constants/ActionTypes";

const _user = sessionStorage.getItem('user');
const _mfaValid = sessionStorage.getItem('mfa');

const INIT_STATE = {
  token: sessionStorage.getItem('token'),
  tempToken: null,
  initURL: '',
  authUser: (typeof _user === 'string') ? JSON.parse(_user) : _user,
  mfa: {
    valid: (_mfaValid !== null && _mfaValid === 'valid') ? true : ''
  },
  bioAuthPassed: null,
  bioAuthChecking: null
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {

    case INIT_URL: {
      return {
        ...state,
        initURL: action.payload
      };
    }

    case SET_USER_BIO_AUTH_CHECKING: {
      return {
        ...state,
        bioAuthChecking: action.payload
      };
    }

    case SET_USER_BIO_AUTH_PASSED: {
      return {
        ...state,
        bioAuthPassed: action.payload
      };
    }

    case SIGNOUT_USER_SUCCESS: {
      return {
        ...state,
        token: null,
        authUser: null,
        initURL: '',
        mfa: {
          valid: ''
        }
      }
    }

    case USER_DATA: {
      return {
        ...state,
        authUser: action.payload,
      };
    }

    case USER_TOKEN_SET: {
      return {
        ...state,
        token: action.payload,
        mfa: {
          valid: true
        },
        tempToken: null
      };
    }

    case TEMPORARY_USER_TOKEN: {
      return {
        ...state,
        tempToken: action.payload,
        token: null
      };
    }

    case MFA_RESPONSE_DATA: {
      return {
        ...state,
        mfa: action.payload,
      };
    }

    default:
      return state;
  }
}
